import * as UH from './../util/UrlHttp'
import axios from 'axios'

export const GetGamesByDate = async (date:string) => {

    return await axios.get(`${UH.BASE_URL}games/list/${date}`, UH.HEADER_HTTP_TOKEN)
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return error;
                });
}

export const GetAllGame = async () => {

    return await axios.get(`${UH.BASE_URL}games/stepMatchs`, UH.HEADER_HTTP_TOKEN)
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return error;
                });
}

export const GetGameByStep = async (step:string) => {

    return await axios.get(`${UH.BASE_URL}games/step/${step}`, UH.HEADER_HTTP_TOKEN)
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return error;
                });
}

export const UpdateGames = async (data:any) => { // data:IGame
    
    return await axios.post(`${UH.BASE_URL}games/update`, data, UH.HEADER_HTTP_TOKEN)
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return error;
                });
}

export const ChangeTeamMatch = async (data:any) => { // data:IGame
    
    return await axios.post(`${UH.BASE_URL}games/ChangeTeamMatch`, data, UH.HEADER_HTTP_TOKEN)
                .then(function (response) {
                    return response;
                })
                .catch(function (error) {
                    return error;
                });
}



